import _403_dp from './pages/_403_dp'
import _404_dp from './pages/_404_dp'
import _500_dp from './pages/_500_dp'
import _uknown_error_dp from './pages/_uknown_error_dp'
import responsive_403_dp from './responsivePages/_403_dp'
import responsive_404_dp from './responsivePages/_404_dp'
import responsive_500_dp from './responsivePages/_500_dp'
import responsive_uknown_error_dp from './responsivePages/_uknown_error_dp'
import { PageJson } from '@wix/thunderbolt-becky-types'

type PagesMap = {
	[id: string]: (externalBaseUrl: string) => PageJson
}

const classicErrorPagesMap = ({
	_403_dp,
	_404_dp,
	_500_dp,
	_uknown_error_dp,
} as any) as PagesMap

const responsiveErrorPagesMap = ({
	_403_dp: responsive_403_dp,
	_404_dp: responsive_404_dp,
	_500_dp: responsive_500_dp,
	_uknown_error_dp: responsive_uknown_error_dp,
} as any) as PagesMap

const getPagesJson = ({
	errorPageId,
	isResponsiveSite,
	externalBaseUrl,
}: {
	errorPageId: string
	isResponsiveSite: boolean
	externalBaseUrl: string
}): PageJson | null => {
	const errorPagesMap = isResponsiveSite ? responsiveErrorPagesMap : classicErrorPagesMap
	const errorPageStructureResolver = errorPagesMap[errorPageId]

	return errorPageStructureResolver?.(externalBaseUrl) || null
}

export default getPagesJson
